import { Pipe, PipeTransform } from '@angular/core';
import { SELECTED_VENDOR } from '@app/_helpers';


const DEFAULT_FRACTION = 2;
export function getLocale(value: any, precision: number, fixed = true, truncateDecimals = false) {
  /*
    Pipe that converts integer to comma seperated selected locale
    123001 -> 1,23,001
    87612.12 -> 87,612.12
    Parameters:
       precision: Add user defined precision, set to 2 by default
       truncateDecimals: If true it will apply default precisionto value
       ex: 100.111 => 100.11
  */
  let valueI = parseFloat(value);
  if (!isNaN(valueI)) {
    if(truncateDecimals) {
      valueI = parseFloat(valueI.toFixed(DEFAULT_FRACTION));
    }
    const applyPrecision = precision != undefined ? precision : DEFAULT_FRACTION; 
    return valueI.toLocaleString(SELECTED_VENDOR.locale,
      {
        minimumFractionDigits: fixed && applyPrecision || 0 // only apply ".00" at end if fixed is true.
      }
    );
  }
  return value;
}

@Pipe({
  name: 'localeConverter'
})
export class LocaleConverterPipe implements PipeTransform {

  transform(values: any | any[], precision: number, fixed = true, truncateDecimals = false): any {
    let retValue = [];
    if (Array.isArray(values)) {
      values.forEach(value => {
        retValue.push(getLocale(value, precision, fixed, truncateDecimals));
      })
      return retValue.join(' | ');
    } else {
      return getLocale(values, precision, fixed, truncateDecimals);
    }
  }

}
